exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n/* Add any component-specific styles here if needed */\n.md-input-container[data-v-72797e84] {\n  margin-bottom: 16px;\n}\n", ""]);

